import { LANGUAGE_CODES, type LanguageCode } from '@silkvoice/core'

const FLAG_MAP: Record<LanguageCode, string> = {
  en: '🇺🇸', ja: '🇯🇵', zh: '🇨🇳', de: '🇩🇪', hi: '🇮🇳', fr: '🇫🇷',
  ko: '🇰🇷', pt: '🇧🇷', it: '🇮🇹', es: '🇪🇸', id: '🇮🇩', nl: '🇳🇱',
  tr: '🇹🇷', tl: '🇵🇭', pl: '🇵🇱', sv: '🇸🇪', bg: '🇧🇬', ro: '🇷🇴',
  ar: '🇸🇦', cs: '🇨🇿', el: '🇬🇷', fi: '🇫🇮', hr: '🇭🇷', ms: '🇲🇾',
  sk: '🇸🇰', da: '🇩🇰', ta: '🇮🇳', uk: '🇺🇦', ru: '🇷🇺', hu: '🇭🇺',
  no: '🇳🇴', vi: '🇻🇳', mn: '🇲🇳',
}

export function langFlag(code: LanguageCode | string): string {
  return FLAG_MAP[code as LanguageCode] ?? ''
}

/**
 * Returns LANGUAGE_CODES sorted alphabetically by their translated label.
 * Pass the `t` function from react-i18next.
 */
export function sortedLanguages(t: (key: string) => string): LanguageCode[] {
  return [...LANGUAGE_CODES].sort((a, b) =>
    t(`languages.${a}`).localeCompare(t(`languages.${b}`)),
  )
}
